import React from 'react';
import CountryFlag from './CountryFlag.tsx';
import NewsItemTitle from './NewsItemTitle.tsx';

interface NewsItemProps {
    date: string;
    country: string;
    countryCode: string;
    bulletStyle: string;
}

const NewsItem: React.FC<NewsItemProps> = ({ date, country, countryCode, bulletStyle }) => {
    return (
        <li className={`relative pl-6 ${bulletStyle}`}>
            <div className="flex flex-row">
                <span>{date}</span>
                <span className="mx-1">-</span>
                <span>
                    <NewsItemTitle date={date} />
                    <CountryFlag countryCode={countryCode} countryName={country} />
                </span>
            </div>
        </li>
    );
};

export default NewsItem;